import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB1Qshjtq_6QHa3xWPgiptkp5nL1RCVQ6I",
  authDomain: "eventix-web.firebaseapp.com",
  databaseURL: "https://eventix-web-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "eventix-web",
  storageBucket: "eventix-web.firebasestorage.app",
  messagingSenderId: "610754955068",
  appId: "1:610754955068:web:38231cc6447dbe78e34039",
  measurementId: "G-HTCBB1ZRC6",
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth };
